import { PaletteColorDTO } from "./palette-color.models";

export class PaletteDTO {
  id: number;
  description: string;
  externalColorCode: string;
  externalId: string;
  colors: PaletteColorDTO[];
}

export class PaletteVM extends PaletteDTO {
  name: string;
  checked?: boolean;
  constructor(dto: PaletteDTO) {
    super();
    Object.assign(this, dto);
    if (this.description && this.externalColorCode) this.name = `${this.externalColorCode} - ${this.description}`;
  }
}

